import React from 'react';
import PropTypes from 'prop-types';
import { ListItemIcon } from '@mui/material';
import AmbGrid from '../AmbGrid';
import PatientAddressIcon from '../icons/PatientAddressIcon';
import { drawerWidth } from '../../../theme';

function PatientItem(props) {
  return (
    <AmbGrid style={{ width: drawerWidth - 50, gap: '12px' }}>
      <AmbGrid style={{ width: 24 }}>
        <ListItemIcon>
          <PatientAddressIcon style={{ height: 24, width: 24, marginTop: '8px' }} />
        </ListItemIcon>
      </AmbGrid>
      <AmbGrid style={{ flexDirection: 'column' }}>
        <aside
          style={{
            width: drawerWidth - 100,
            marginLeft: -5,
            marginBottom: -3,
            color: '#2e424d',
            whiteSpace: 'nowrap',
            fontSize: 14,
            lineHeight: '24px',
          }}
        >
          Patient Address
        </aside>
        <span
          style={{
            width: drawerWidth - 100,
            marginLeft: -5,
            color: '#797d80',
            whiteSpace: 'nowrap',
            fontWeight: 400,
          }}
        >
          {props.children.name}
        </span>
      </AmbGrid>
    </AmbGrid>
  );
}

PatientItem.propTypes = {
  children: PropTypes.oneOfType([PropTypes.shape(), PropTypes.node]).isRequired,
};

export default PatientItem;
